<template>
  <div class="mt-6 bg-base-100 rounded-lg p-6">
    <div>
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold">
          {{
            isEditing
              ? "Redaguoti neregistruotą pavėžėjimą"
              : "Įtraukti neregistruotą pavėžėjimą"
          }}
        </h2>
        <button
          v-if="isEditing"
          @click="confirmDelete(formData.id)"
          class="btn btn-sm btn-ghost"
          title="Ištrinti"
        >
          <DefaultIcon name="trash" size="w-5 h-5" />
        </button>
      </div>

      <form @submit.prevent="handleSubmit" class="space-y-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <fieldset class="fieldset w-full">
            <legend class="fieldset-legend">Data</legend>
            <input
              v-model="formData.date"
              type="date"
              class="input w-full"
              required
            />
          </fieldset>
          <fieldset class="fieldset w-full">
            <legend class="fieldset-legend">Keleivių skaičius</legend>
            <input
              v-model="formData.clients_count"
              type="number"
              :min="1"
              class="input w-full"
              required
            />
          </fieldset>
        </div>

        <div class="grid grid-cols-1 gap-4">
          <!-- Description -->
          <fieldset class="fieldset">
            <legend class="fieldset-legend">Pastaba</legend>
            <textarea
              v-model="formData.notice"
              class="textarea h-24 w-full"
            ></textarea>
          </fieldset>
        </div>

        <div if="isEditing" class="text-sm text-base-content/60">
          <p v-if="formData.created_by">
            Sukurta: {{ formData.created_by }} ({{ formData.created_at }})
          </p>
          <p v-if="formData.updated_by">
            Redaguota: {{ formData.updated_by }} ({{ formData.updated_at }})
          </p>
        </div>

        <!-- Form Actions -->
        <div class="flex justify-end gap-4 mt-8">
          <button type="button" class="btn btn-ghost" @click="goBack('/unregistered-trips')">
            Atšaukti
          </button>
          <button
            type="submit"
            class="btn btn-success"
            :disabled="unregisteredTripStore.isLoading"
          >
            {{ isEditing ? "Atnaujinti" : "Pridėti" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { useUnregisteredTripStore } from "@/stores/unregisteredTrips";
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { useGoBack } from "@/composables/navigation/useGoBack";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const route = useRoute();
const goBack = useGoBack();
const unregisteredTripStore = useUnregisteredTripStore();

const isEditing = computed(() => !!route.params.id);

const formData = ref({
  date: "",
  clients_count: 1,
  notice: "",
});

onMounted(async () => {
  if (isEditing.value) {
    try {
      const unregisteredTrip = await unregisteredTripStore.fetchTripById(
        route.params.id,
      );
      if (unregisteredTrip) {
        formData.value = { ...unregisteredTrip };
      } else {
        goBack("/unregistered-trips");
      }
    } catch (error) {
      console.error("Failed to fetch unregistered trips: ", error);
      goBack("/unregistered-trips");
    }
  }
});

const handleSubmit = async () => {
  try {
    if (isEditing.value) {
      await unregisteredTripStore.updateTrip(route.params.id, formData.value);
    } else {
      await unregisteredTripStore.addTrip(formData.value);
    }
    goBack("/unregistered-trips");
  } catch (error) {
    console.error("Failed to save unregistered trip:", error);
  }
};

const confirmDelete = async (id) => {
  if (confirm("Ar tikrai norite ištrinti šį įrašą?")) {
    try {
      await unregisteredTripStore.deleteTrip(id);
      goBack("/unregistered-trips");
    } catch (error) {
      console.error("Failed to delete unregistered trip:", error);
    }
  }
};
</script>
